// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-dXJ1f"};